import dayjs, { ConfigType } from 'dayjs';

const dateComparer = (a: ConfigType | undefined, b: ConfigType | undefined) => {
  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const dateA = dayjs(a);
  const dateB = dayjs(b);

  if (dateA.isBefore(dateB)) return -1;
  if (dateA.isAfter(dateB)) return 1;
  return 0;
};

export default dateComparer;
